import { registerModuleDataProvider } from '../../providers/CustomDataProvider';
import { relayDepositDataProvider } from './dataProvider';

registerModuleDataProvider('relay', relayDepositDataProvider);
